import React from "react";
import { getInsurerName } from "../../utils/insurer-name";

/**
 * Pre-payment commission-rebate statement — TIMB NDDP item 2 (Ansa-Support#30).
 *
 * BNM's Guidelines on Product Transparency and Disclosure, para 8.2.3, require the customer
 * to be told, before the final confirmation of purchase, that the same product may be
 * available with a rebate on commission — or commission-free — direct from the insurer.
 *
 * The acknowledgement checkbox on the package page already carries this wording. This is the
 * same statement repeated on the payment summary, which is the last screen before the
 * customer leaves for the payment gateway, so the requirement is met on the final
 * confirmation page itself rather than only two steps earlier.
 *
 * Font: the guideline's floor is 8 POINT = 10.67 CSS px. This renders at 12px (≈9pt). Do not
 * reduce it below 12px.
 */
const CommissionRebateNotice = ({ insurerName }) => {
	if (!insurerName) return null;

	return (
		<div
			className="mt-3 p-3"
			style={{
				border: "1px solid #ddd",
				borderRadius: "8px",
				background: "#fafafa",
			}}
		>
			<span style={{ fontSize: "12px", lineHeight: "18px" }}>
				{`Advance Fin Advisory Sdn Bhd will receive a commission for providing takaful/insurance-related services, and by proceeding, consumers have an option to purchase similar product with a rebate on commission or is commission-free if purchased directly from ${getInsurerName(
					insurerName
				)}'s own website or physical branches.`}
			</span>
		</div>
	);
};

export default CommissionRebateNotice;
